import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import pt_BR from '@/locales/pt_BR.json';

export type MessageSchema = typeof en;

export function createI18nPlugin(initialLocale: string = 'en') {
    return createI18n<[MessageSchema], 'en' | 'pt_BR'>({
        legacy: false,
        globalInjection: true,
        locale: initialLocale,
        fallbackLocale: 'en',
        messages: {
            en,
            pt_BR,
        },
    });
}
